import i18n from "@/zapi-frontend/shared/i18n";
import { formatPortfolioDate } from "@/zapi-frontend/pages/ProjectsPage/lib/formatPortfolioDate";

const STEPS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["minute", 60],
  ["hour", 24],
  ["day", 7]
];

export function formatUpdatedAgo(iso?: string): string {
  if (!iso) return formatPortfolioDate(iso);
  const time = new Date(iso).getTime();
  if (Number.isNaN(time)) return formatPortfolioDate(iso);
  const format = new Intl.RelativeTimeFormat(i18n.language, { numeric: "auto", style: "short" });
  let value = Math.round((time - Date.now()) / 60_000);
  if (value > -1) return format.format(0, "minute");
  for (const [unit, size] of STEPS) {
    if (Math.abs(value) < size) return format.format(value, unit);
    value = Math.round(value / size);
  }
  return formatPortfolioDate(iso);
}
